<template>
    <div>
        <input type="hidden" :name="name" v-model="fieldValue">
        <form-select
                v-show="shouldDisplaySelect"
                :name="name+'Select'"
                :slug="slug+'_select'"
                :label="selectLabel || label"
                :hint="hint"
                :error="error"
                :validations="validations"
                :value="value"
                :values="regions || {}"
                :placeholder="placeholder"
                :required="required"
                :disabled="disabled"
                ref="select"
        ></form-select>

        <form-input
                v-show="!shouldDisplaySelect"
                :name="name+'Input'"
                :slug="slug+'_input'"
                :label="inputLabel || label"
                :hint="hint"
                :error="error"
                :validations="validations"
                :value="value"
                :placeholder="placeholder"
                :required="required"
                :disabled="disabled"
                ref="input"
        ></form-input>
    </div>
</template>

<script>
  import FormField from "rubinred/forms/js/mixins/FormField";

  export default {
    mixins: [FormField],
    props: {
      value: {
        type: String,
        default: null,
      },
      values: {
        type: Object,
        required: true,
      },
      country: {
        type: String,
        default: null,
      },
      placeholder: {
        type: [String, Boolean],
        default: false,
      },
      countryAttribute: {
        type: String,
        default: 'country',
      },
      selectLabel: {
        type: String,
        default: null
      },
      inputLabel: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        currentCountry: this.country,
      };
    },
    computed: {
      regions() {
        return this.values[this.currentCountry];
      },
      shouldDisplaySelect() {
        return !!this.regions;
      }
    },
    mounted() {
      this.$root.$on('field.changed', field => {
        if (field.slug === this.countryAttribute) {
          this.currentCountry = field.getValue();
        }
      });

      this.$root.$on('field.setValue', field => {
        if (field.slug === this.countryAttribute) {
          this.currentCountry = field.getValue();
        }
      });

      this.$refs.select.$on('change', value => {
        if (this.shouldDisplaySelect) {
          this.fieldValue = value
        }
      });

      this.$refs.input.$on('change', value => {
        if (!this.shouldDisplaySelect) {
          this.fieldValue = value
        }
      });
    },
    methods: {
      validateField(fields = {}, labels = {}) {
        if (this.shouldDisplaySelect) {
          return this.$refs.select.validateField(fields, labels);
        }

        return this.$refs.input.validateField(fields, labels);
      },
      setValue(value) {
        this.fieldValue = value;

        if (!isNaN(value)) {
          this.currentCountry = Object.keys(this.values).find(country => this.values[country].hasOwnProperty(value));
          this.$refs.select.setValue(value);

          return;
        }

        let country = Object.keys(this.values).find(country => {
          let tmpValue = Object.keys(this.values[country]).find(key => this.values[country][key] === value);
          if (tmpValue !== undefined) {
            value = tmpValue;
          }

          return tmpValue !== undefined;
        });

        if (country !== undefined) {
          this.currentCountry = country;
          this.$refs.select.setValue(value);

          return;
        }

        //we don't have any info about the country
        this.$refs.input.setValue(value);
      },
    },
    provide: function () {
      return {
        register: () => null,
      };
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/addressing/assets/js/components/FormRegionPicker.vue